import axios from 'axios'
import applicationConstants from '@/constants/ApplicationConstants'
import AuthenticationService from '@/services/AuthenticationService.vue'

export function _request (url, data) {
  const _data = data
    ? JSON.stringify({
      ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
      ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion,
      ...data
    })
    : JSON.stringify({
      ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
      ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion
    })

  return AuthenticationService.authUserValue ? axios.post(
    applicationConstants.publicServerBaseUrl + url,
    _data,
    {
      crossdomain: true,
      headers: {
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        common: {
          Authorization: AuthenticationService.authUserValue
        }
      }
    }
  )
    : null
}



// WEBPACK FOOTER //
// ./src/helpers/_request.js